import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Roles } from 'Core/enums';
import { NgxPermissionsService } from 'ngx-permissions';
import { map, Observable, switchMap } from 'rxjs';
import { UserResolver } from '../resolvers/user.resolver';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard implements CanActivate {
  constructor(
    private userResolver: UserResolver,
    private ngxPermissionsService: NgxPermissionsService
  ) {}

  public canActivate(): Observable<boolean> | boolean {
    return this.userResolver.resolve().pipe(
      switchMap(() => this.ngxPermissionsService.permissions$),
      map(permissions => !!permissions[Roles.ROLE_ADMIN])
    );
  }
}
